import { useEffect, useState } from 'react';

/**
 * Returns whether a scroll element has non-zero dimensions (i.e. is not inside a `display: none` container).
 * Uses ResizeObserver to reactively update when visibility changes.
 */
export const useIsScrollElementVisible = (scrollElement: HTMLElement | null) => {
  const [isVisible, setIsVisible] = useState(() => {
    if (!scrollElement) {
      return false;
    }

    const rect = scrollElement.getBoundingClientRect();

    return rect.height > 0 && rect.width > 0;
  });

  useEffect(() => {
    if (!scrollElement) {
      setIsVisible(false);
      return;
    }

    const rect = scrollElement.getBoundingClientRect();
    setIsVisible(rect.height > 0 && rect.width > 0);

    const observer = new ResizeObserver(() => {
      const rect = scrollElement.getBoundingClientRect();
      setIsVisible(rect.height > 0 && rect.width > 0);
    });

    observer.observe(scrollElement);
    return () => observer.disconnect();
  }, [scrollElement]);

  return isVisible;
};
